// ── Micro-interaction utilities ──────────────────────────

// Confetti burst — call when guest RSVPs attending
export function fireConfetti() {
  import('canvas-confetti').then(({ default: confetti }) => {
    confetti({
      particleCount: 80,
      spread: 70,
      origin: { y: 0.6 },
      colors: ['#C4826A', '#9BAF9B', '#F3D5C5', '#FAFAF8', '#1A1A1A'],
      ticks: 200,
    })
    setTimeout(() => confetti({
      particleCount: 40,
      spread: 50,
      origin: { y: 0.5 },
      colors: ['#C4826A', '#9BAF9B', '#F3D5C5'],
      ticks: 150,
    }), 300)
  })
}

// Floating hearts — call after thank-you sent
export function floatHearts(anchorEl) {
  const container = document.createElement('div')
  container.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:9999;overflow:hidden'
  document.body.appendChild(container)

  const rect = anchorEl?.getBoundingClientRect()
  const x = rect ? rect.left + rect.width / 2 : window.innerWidth / 2
  const y = rect ? rect.top : window.innerHeight / 2

  for (let i = 0; i < 6; i++) {
    const heart = document.createElement('div')
    const size = 14 + Math.random() * 12
    const dx = (Math.random() - 0.5) * 80
    heart.style.cssText = `
      position:absolute;
      left:${x + (Math.random() - 0.5) * 40}px;
      top:${y}px;
      font-size:${size}px;
      animation: floatUp 1.2s ease-out ${i * 0.12}s forwards;
      opacity:0;
      transform:translateX(${dx}px);
    `
    heart.textContent = '❤️'
    container.appendChild(heart)
  }

  setTimeout(() => document.body.removeChild(container), 2000)
}

// Inject float-up keyframe once
if (!document.getElementById('okoiya-anim-style')) {
  const style = document.createElement('style')
  style.id = 'okoiya-anim-style'
  style.textContent = `
    @keyframes floatUp {
      0%   { opacity:0; transform: translateY(0) scale(0.5); }
      20%  { opacity:1; }
      100% { opacity:0; transform: translateY(-90px) scale(1.1); }
    }
    @keyframes pulse-number {
      0%, 100% { transform: scale(1); }
      50%       { transform: scale(1.18); color: #C4826A; }
    }
    .pulse-digit {
      animation: pulse-number 0.6s ease-in-out infinite;
      display: inline-block;
    }
  `
  document.head.appendChild(style)
}
